import * as React from 'react';
import { createUseStyles } from 'react-jss';

import { FieldWrap } from './index';
import { FormError } from '../../interfaces';
import { ExpandIcon } from '../Icons';

const useStyles = createUseStyles({
    select: {
        appearance: 'none',
        borderRadius: 0,
        cursor: 'pointer',
        width: '100%'
    },
    selectWrap: {
        position: 'relative'
    },
    iconWrap: {
        position: 'absolute',
        right: '.6rem',
        marginTop: '-14px',
        cursor: 'pointer',
        pointerEvents: 'none',
        top: '50%'
    }
});

interface SelectProps {
    name: string;
    label: string;
    emptySelectionLabel: string;
    options: {
        identifier: string;
        label: string;
        value?: string;
    }[];
    error?: FormError;
    required?: boolean;
    register: (options: object) => any;
    validation?: object;
}

const Select: React.FC<SelectProps> = ({
    name,
    label,
    emptySelectionLabel,
    error,
    options,
    register,
    required = false,
    validation
}: SelectProps) => {
    const classes = useStyles();

    return (
        <FieldWrap label={label} error={error}>
            <div className={classes.selectWrap}>
                <select name={name} ref={register({ required, ...validation })} className={classes.select}>
                    <option value="">{emptySelectionLabel}</option>
                    {options.map(option => (
                        <option key={option.identifier} value={option.value || option.label}>
                            {option.label}
                        </option>
                    ))}
                </select>
                <span className={classes.iconWrap}>
                    <ExpandIcon />
                </span>
            </div>
        </FieldWrap>
    );
};

export default React.memo(Select);
